const ITEMS = [
  "Captação de Pacientes",
  "Estruturação Comercial",
  "CRM Pulse Hub",
  "Treinamento de Equipes",
  "Automações Inteligentes",
  "Pulse Academy",
  "Indicadores em Tempo Real",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="editorial-marquee" className="bg-graphite border-y border-gold/15 py-6 overflow-hidden" aria-hidden="true">
      <div className="flex w-max animate-marquee gap-0">
        {row.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-display font-semibold uppercase tracking-[0.24em] text-sm text-bone/60 px-8 whitespace-nowrap">
              {item}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-gold shrink-0" />
          </span>
        ))}
      </div>
    </section>
  );
}
